import {useState, useContext} from "react"
import { Link } from "react-router-dom"
import { useHistory } from 'react-router-dom'
import {
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from "@mui/material";
import EmailState from "../../common/components/EmailState"
import UserContext from "../../common/helpers/userContext";
import signHandler from "../../common/helpers/signHandler"
import AuthFormWrapper from '../../common/components/AuthFormWrapper'
import { createService } from '../../common/services/serviceFactory'

function Login() {
  const [loginObject, setLoginObject] = useState({
    email: "admin@milytravel.com", // Pre-populate for demo
    password: "123", // Pre-populate for demo
    confirmationPassword: ""
  });
  const [isLoading, setIsLoading] = useState(false);
  const [selectedRole, setSelectedRole] = useState("admin"); // Default role for demo

  const { routeToNavigate, setClientData, setAccessToken } = useContext(UserContext);
  const Router = useHistory();

  const onSubmit = async (e) => {
    e.preventDefault();
    setIsLoading("Loading");
    const credentials = {
      email: loginObject.email,
      password: loginObject.password,
      role: selectedRole, // Pass selected role for demo mode
    };
    const authService = createService('auth');
    try {
      const response = await authService.login(credentials);
      const { user: clientData, token: accessToken } = response;
      signHandler(accessToken, clientData, setClientData, setAccessToken);
      Router.push(routeToNavigate);
      setIsLoading("success");
    } catch (error) {
      setIsLoading("fail");
      console.log("Login error:", error);
    }
  };

  const handleData = input => e => {
    setLoginObject({ ...loginObject, [input]: e.target.value });
  };

  const handleRoleChange = (event) => {
    const role = event.target.value;
    setSelectedRole(role);
    // Pre-populate credentials based on role for demo
    if (role === "admin") {
      setLoginObject({ ...loginObject, email: "admin@milytravel.com", password: "123" });
    } else {
      setLoginObject({ ...loginObject, email: "cliente1@example.com", password: "123" });
    }
  };

  return (
    <AuthFormWrapper onSubmit={onSubmit}>
      <div className="absolute putTop">
        <EmailState stateOfEmail={isLoading} />
      </div>

      <h3 style={{ textAlign: "center" }}>Iniciar Sesión</h3>

      <FormControl variant="standard" fullWidth sx={{ marginBottom: "20px" }}>
        <InputLabel id="role-select-label">Seleccionar Rol</InputLabel>
        <Select
          labelId="role-select-label"
          id="role-select"
          value={selectedRole}
          label="Seleccionar Rol"
          onChange={handleRoleChange}
        >
          <MenuItem value="admin">Administrador</MenuItem>
          <MenuItem value="user">Usuario</MenuItem>
        </Select>
      </FormControl>

      <TextField
        name={"email"}
        sx={{ width: "100%" }}
        value={loginObject.email}
        label={"Email"}
        onChange={handleData("email")}
        required
        variant="standard"
      />

      <TextField
        type={"password"}
        name={"password"}
        sx={{ width: "100%" }}
        value={loginObject.password}
        label={"Contraseña"}
        onChange={handleData("password")}
        required
        variant="standard"
      />
      <div>
        <Link to={"sendEmailToRecoverPass"}>¿Ha olvidado su contraseña? </Link>
        /
        <Link to={"register"}> Regístrate</Link>
      </div>

      <button className="redButton" type="submit">Iniciar Sesión</button>
    </AuthFormWrapper>
  );
}

export default Login